//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useEffect, useState } from "react";
import { forwardRef } from "react";

import { useTheme } from '@mui/material/styles';
import {
  InputBase,
} from '@mui/material';

// === CONSTANTS ===
import {SUCCESS_CODE} from "constants/general";

//#endregion


export default forwardRef( Standard );

//-----------------------------------------------------------------
function Standard( props, ref ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const { content, is_read_only, handleChange, handleFocus } = props;

  const [ value, setValue ] = useState( content );

  const [ timeout_change, setTimeoutChange ] = useState(null);

  //#endregion

  //#region [STYLES]

  const style       = { width:'100%', paddingLeft:'1rem' };
  const style_input = { textTransform:'uppercase' };

  const INPUT = {
    sx           : style               ,
    value        : value               ,
    onChange     : onChange            ,
    onFocus      : handleFocus         ,
    autoComplete : "off"               ,
    disabled     : is_read_only        ,
    inputProps   : { sx: style_input, ref : ref } ,
  }

  //#endregion

  //#region

  useEffect( () => {
    setValue( content );
  }, [content] );

  //#endregion

  //#region [EVENTS]

  // After 500ms of no typing, propigate the changes
  //-----------------------------------------------------------------
  function onChange( event ) {
    //-----------------------------------------------------------------
    try {
      clearTimeout( timeout_change );

      const value_new = event.target.value.toUpperCase();
      setValue( value_new );

      // Don't need to propigate if value is the same
      if( value_new === content ) return;

      const timeout_id = setTimeout( ()=> { if( handleChange ) handleChange( value_new ) }, 500 );
      setTimeoutChange( timeout_id );
    } catch (error) {
      console.warn(error);
    }
  }

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return <InputBase {...INPUT} />;
  }

  //#endregion

  return display();
}